import { createReducer, on } from '@ngrx/store';
import { updateAllItemCodeStringValues } from './item-code-strings.actions'
import { CodeStringGroup, CodeStringSegment, CodeStringValues } from 'src/app/models/pricing-view-models';



//cns: all code strings in same object
// export interface ItemCodeStringValuesState {
//   itemCodeStrings: CodeStringValues;
// }

// export interface CodeStringState {
//   codeStringName: string;  //do not change the property "name" - this is used to identify the code string in other areas of the app
//   codeStringDisplayName: string;  //can change based on user reqwuirements
//   codeStringValue: string;
// }
export const initialCodeStringValues: CodeStringValues = {
  CodeStringGroupValues: []
  //itemCodeStrings: []
  // itemCodeStrings: [
  //   {
  //     codeStringName: 'common',
  //     codeStringDisplayName: 'Common',
  //     codeStringValue: ''
  //   },
  //   {
  //     codeStringName: 'valve',
  //     codeStringDisplayName: 'Valve',
  //     codeStringValue: ''
  //   },
  //   {
  //     codeStringName: 'ceilingPanel',
  //     codeStringDisplayName: 'Ceiling Panel',
  //     codeStringValue: '',
  //   }
  // ]

};

export const itemCodeStringValuesFeatureKey = 'itemCodeStringsState';

export const itemCodeStringValuesReducer = createReducer(
  initialCodeStringValues,
  // on(loadAllItemCodeStringValues, (state): CodeStringValues => {
  //   return { ...state };
  // }),
  on(updateAllItemCodeStringValues, (state, {  CodeStringValues }): CodeStringValues => {
    //console.log('updateAllItemCodeStringValues', 'p1', state, 'p2', CodeStringValues);
    let data = CodeStringValues.CodeStringGroupValues;
    let rtn = { ...state, CodeStringGroupValues: data } as CodeStringValues;
    //console.log('updateAllItemCodeStringValues', 'rtn', rtn);
    return rtn;
  }), 
);

// // used to reset state
// export const initialItemCodeStringsState: ItemAllCodeStringsState = {
//   itemCodeStrings: []
//   // itemCodeStrings: [
//   //   {
//   //     codeStringName: 'common',
//   //     codeStringDisplayName: 'Common',
//   //     codeStringValue: ''
//   //   },
//   //   {
//   //     codeStringName: 'valve',
//   //     codeStringDisplayName: 'Valve',
//   //     codeStringValue: ''
//   //   },
//   //   {
//   //     codeStringName: 'ceilingPanel',
//   //     codeStringDisplayName: 'Ceiling Panel',
//   //     codeStringValue: '',
//   //   }
//   // ]
// };

// export interface ProductCodeStringSegmentsState {
//   codeStringSegments: ProductCodeStringSegment[];
//   currentCommonString: string;
//   currentValveString: string;
//   currentCeilingPanelString: string;
// }

// export const initialProductCodeStringSegmentsState: ProductCodeStringSegmentsState = {
//   codeStringSegments: [],
//   currentCommonString: Array(30).fill(' ').join(''),
//   currentValveString: Array(30).fill(' ').join(''),
//   currentCeilingPanelString: Array(30).fill(' ').join('')
// };

// export enum CodeStringType {
//   COMMON,
//   VALVE,
//   CEILING_PANEL
// }

// export const productCodeStringSegmentsFeatureKey = 'productCodeStringSegmentsState';

// export const productCodeStringSegmentsReducer = createReducer(
//   initialProductCodeStringSegmentsState,
//   on(loadCodeStringSegmentsSuccess, (state, { codeStringSegments }): ProductCodeStringSegmentsState => {
//     return { ...state, codeStringSegments };
//   }),
//   on(loadCodeStringSegmentsFailure, (state, { error }): ProductCodeStringSegmentsState => {
//     console.error(error);
//     return state;
//   }),
//   on(resetCommonCodeString, (state): ProductCodeStringSegmentsState => {
//     return {
//       ...state,
//       currentCommonString: initialProductCodeStringSegmentsState.currentCommonString
//     } as ProductCodeStringSegmentsState;
//   }),
//   on(resetValveCodeString, (state): ProductCodeStringSegmentsState => {
//     return {
//       ...state,
//       currentValveString: initialProductCodeStringSegmentsState.currentValveString
//     } as ProductCodeStringSegmentsState;
//   }),
//   on(resetCeilingPanelCodeString, (state): ProductCodeStringSegmentsState => {
//     return {
//       ...state,
//       currentCeilingPanelString: initialProductCodeStringSegmentsState.currentCeilingPanelString
//     } as ProductCodeStringSegmentsState;
//   }),
//   on(resetCodeStrings, (state): ProductCodeStringSegmentsState => {
//     return {
//       ...state,
//       currentCommonString: initialProductCodeStringSegmentsState.currentCommonString,
//       currentValveString: initialProductCodeStringSegmentsState.currentValveString,
//       currentCeilingPanelString: initialProductCodeStringSegmentsState.currentCeilingPanelString
//     } as ProductCodeStringSegmentsState;
//   }),
//   on(updateCommonCodeString, updateSpecifiedCodeString(CodeStringType.COMMON)),
//   on(updateValveCodeString, updateSpecifiedCodeString(CodeStringType.VALVE)),
//   on(updateCeilingPanelCodeString, updateSpecifiedCodeString(CodeStringType.CEILING_PANEL)),
// );

// function updateSpecifiedCodeString(codeStringType: CodeStringType) {
//   return (state: ProductCodeStringSegmentsState, {
//     productModelName,
//     productAccessoryTypeName,
//     value
//   }) => {
//     let segmentLength = 0;
//     let segmentPosition = 0;

//     const matchModel = state.codeStringSegments.find(item => {
//       if (item.ProductModelName === productModelName &&
//         item.ProductAccessoryTypeName === productAccessoryTypeName) {
//         segmentLength = item.SegmentLength;
//         segmentPosition = item.SegmentPosition;
//         return true;
//       }
//       return false;
//     });

//     if (!matchModel) {
//       return state;
//     }

//     let stringToUpdate: keyof ProductCodeStringSegmentsState = null;

//     switch (codeStringType) {
//       case CodeStringType.COMMON:
//         stringToUpdate = 'currentCommonString'
//         break;
//       case CodeStringType.VALVE:
//         stringToUpdate = 'currentValveString'
//         break;
//       case CodeStringType.CEILING_PANEL:
//         stringToUpdate = 'currentCeilingPanelString'
//     }

//     if (codeStringType === CodeStringType.CEILING_PANEL && value === 'reset') {
//       value = initialProductCodeStringSegmentsState.currentCeilingPanelString;
//     }

//     return updateConfigString(
//       state,
//       stringToUpdate,
//       segmentPosition,
//       segmentLength,
//       value
//     );
//   };
// }

// function updateConfigString(
//   state: ProductCodeStringSegmentsState,
//   stringToUpdate: string,
//   segmentPosition: number,
//   segmentLength: number,
//   value: string
// ): ProductCodeStringSegmentsState {

//   //split with empty string to convert string to array - str.split('')[0] = 'a'
//   const newConfigString = state[stringToUpdate].split('');
//   newConfigString.splice(segmentPosition - 1, segmentLength, value);
//   const newCurrent = newConfigString.join('');

//   return {
//     ...state,
//     [stringToUpdate]: newCurrent,
//   };
//}
